import axios from "axios";
import { formatHTTPErrorMessage, notification } from "../shared/notifications";
import Endpoints from "../shared/endpoints";
import globalUtils from "../utils/globalUtils";
import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME } from "../shared/constant";

export const API_ENDPOINT = process.env.REACT_APP_CLAP_BACKEND;

const api = axios.create({
  baseURL: API_ENDPOINT,
  headers: {},
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN_NAME);
    if (accessToken && config.headers)
      config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest.retry) {
      originalRequest.retry = true;

      const refreshToken = localStorage.getItem(REFRESH_TOKEN_NAME);
      if (refreshToken) {
        try {
          const res = await axios.post(
            `${API_ENDPOINT}${Endpoints.refreshToken}`,
            {
              refresh: refreshToken,
            },
          );
          if (res.data.access) {
            localStorage.setItem(ACCESS_TOKEN_NAME, res.data.access);
            // axios.defaults.headers.common.Authorization = `Bearer ${res.data.access}`;
            /*  if (originalRequest.headers)
              originalRequest.headers.Authorization = `Bearer ${res.data.access}`; */
          }
        } catch (err) {
          /* Refresh Error */
          globalUtils.removeTokens();
        }
      } else {
        /* No Refresh Token */
        globalUtils.removeTokens();
      }

      return api(originalRequest);
    }

    if (error.response && error.response.status === 403)
      globalUtils.removeTokens();

    if (
      !(
        error.response.status === 400 &&
        error.response.data.identifier === "incomplete_payment"
      )
    ) {
      notification({
        type: "error",
        title:
          error.response.status === 401 &&
          error?.response?.data.detail ===
            "Given token not valid for any token type"
            ? "Sign in Required"
            : "Error occurred",
        description: formatHTTPErrorMessage(error),
      });
    }

    return Promise.reject(error);
  },
);

export default api;
